// @flow
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { actions as DeliverActions } from '../duck';
import Deliver from '../components/Deliver';

import type { RootState } from '../../../../index';

function mapStateToProps(state: RootState) {
  return {
    locale: state.locale,
    localValues: state.localValues,
    order: state.order.order,
    couriers: state.order.sale.deliver.couriers,
    motives: state.report.motives,
  }
}

function mapDispatchToProps(dispatch: Function) {
  return bindActionCreators(DeliverActions, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(Deliver);



// WEBPACK FOOTER //
// ./src/modules/order/Sale/deliver/containers/DeliverContainer.jsx